// ----------------------------------------------------------------------------
// Snippet: Country Switcher
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_product-group-dropdown.scss';
import registerCustomElement from 'scripts/helpers/register-custom-element';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var GROUP_DROPDOWN = '.group-dropdown__container';
var GROUP_DROPDOWN_TOGGLE = '.group-dropdown__toggle';
var GROUP_DROPDOWN_LIST = '.group-dropdown__list';
var OPEN_CLASS = 'is-open';
var body = document.querySelector('body');
var groupDropdown = document.querySelector(GROUP_DROPDOWN);
var groupDropdownToggle = document.querySelector(GROUP_DROPDOWN_TOGGLE);
var groupDropdownList = document.querySelector(GROUP_DROPDOWN_LIST);
function closeGroupDropdown(toggle, list, switcher) {
  toggle.classList.remove(OPEN_CLASS);
  list.classList.remove(OPEN_CLASS);
  switcher.classList.remove(OPEN_CLASS);
  toggle.setAttribute('aria-expanded', 'false');
}

// Close the switcher if clicking outside
body.addEventListener('click', function (event) {
  if (event.target.closest(GROUP_DROPDOWN_TOGGLE) === null && document.querySelector(GROUP_DROPDOWN_TOGGLE) != null) {
    closeGroupDropdown(groupDropdownToggle, groupDropdownList, groupDropdown);
  }
});
class GroupDropdown extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector('.group-dropdown__toggle'),
      panel: this.querySelector('.group-dropdown__list')
    };
    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.elements.panel.lastElementChild.addEventListener('keydown', event => {
      if (event.keyCode == 9) {
        this.parentNode.toggleAttribute('hidden');
      }
    });
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    console.log('onItemClick', event.currentTarget.href);
    event.preventDefault();
    var href = event.currentTarget.href;
    // this.elements.input.value = event.currentTarget.dataset.value;
    if (href) window.location.href = href;
  }
  toggleSelector() {
    if (this.elements.panel.hasAttribute('hidden')) {
      this.openSelector();
    } else {
      this.hidePanel();
    }
  }
  openSelector() {
    console.log(this.elements.button);
    this.elements.panel.removeAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    requestAnimationFrame(() => {
      this.elements.panel.focus();
    });
  }
  closeSelector(event) {
    var shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
registerCustomElement('product-group-dropdown', GroupDropdown);